import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, Injector, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppClientContext } from '../../../_appCommon/base/AppClientContext';
import { AppEventNames, CRUDCASESTEPS, CRUDCASESTEPSEXTENDED } from '../../../_appCommon/base/Constants';
import { BroadcastManager } from '../../../_appCommon/base/BroadcastManager';
import { CRUDFormControllerBase } from '../../../_appCommon/base/CRUDFormControllerBase';
import { CaseDataService } from '../../../_dataservices/CaseDataService';
import { CaseStageDataService } from '../../../_dataservices/CaseStageDataService';
import { CaseWizardService } from 'src/app-client/_dataservices/CaseWizardService';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { ECOMMERCE_USER_TOKEN } from 'src/app/_appCommon/base/Constants';
import { ICreateBlankCommandCaseStage, ICreateBlankCommandSetup, StatusesID } from '../../../_appCommon/base/AppInterfaceAndBaseClasses';
import { PatientDataService } from '../../../_dataservices/PatientDataService';
import { SetupDataService } from '../../../_dataservices/SetupDataService';
import { SystemServicesDataService } from 'src/app-client/_dataservices/security/SystemServicesDataService';
import { UrlQueryDef } from '../../../_appCommon/base/UrlQueryDef';
import { HomeComponent } from 'src/app-admin/home/home.component';

@Component({
  selector: 'app-client-crud-case2',
  templateUrl: './crud-case.component.html',
  styleUrls: ['./crud-case.component.css'],
  providers: [CaseDataService, PatientDataService, CustomerDataService, SetupDataService, CaseStageDataService, SystemServicesDataService]
})
export class CrudCaseComponent extends CRUDFormControllerBase<CaseDataService> implements AfterViewChecked
{

  @HostListener("window:load", ["$event"]) loadHandler(event: Event) {
    this.router.navigate(['/ecommerce/mis-casos']);
  }

  @ViewChild('confirmCaseDialog') protected confirmCaseDialog: any;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;

  private crudCaseStepsArray= CRUDCASESTEPS;
  public crudCaseStepsArrayExtended = CRUDCASESTEPSEXTENDED;
  public currentRoute: string;
  public customerId: number;
  public isCompositeFormValid: boolean = false;
  public isPhotographyFormValid: boolean = false;
  public isSTLFormValid: boolean = false;
  public loading = false;
  public loadingStep: boolean = false;
  public paramStep: any = null;
  public prescriptionItems = Array(9).fill(1);
  public previousRoute: string;
  public protocolForUseAlignersData: any;
  public queryParams: any = {};
  public saveCase: boolean = false;
  public selectedStepIndex: number = 0;
  public setupData: any;
  public showConfirmButton: boolean = false;
  public stackRoutes: string[] = [];
  public caseStages: any []=[];
  public finalStep: boolean = false;
  public size700_1020 = false;
  public formStep5Valid:boolean =false;
  public formStep1Valid:boolean =false;
  public formStep2Valid:boolean =false;
  public formStep3Valid:boolean =false;
  public formStep4Valid:boolean =false;
  public formStep9Valid:boolean =false;
  public formStep6Valid:boolean =false;
  public formStep7Valid:boolean =false;
  public finalStepValid:boolean  =false;
  private unsubscribe: Subject<void> = new Subject();

  public notCompleted: boolean =false;
  public currentStepNumber: number= 2;
  public newCase:boolean = false;

  constructor(
    activatedRoute: ActivatedRoute,
    caseDataService: CaseDataService,
    private caseStageDataService: CaseStageDataService,
    private customerDataService: CustomerDataService,
    private injector: Injector,
    private patientDataService: PatientDataService,
    private router: Router,
    private setupDataService: SetupDataService,
    private systemServicesDataService: SystemServicesDataService,
    public caseWizardService: CaseWizardService,
    private cdr:ChangeDetectorRef
  )
  {
      super(activatedRoute, caseDataService);
  }

  ngAfterViewChecked()
  {
    this.cdr.detectChanges();
  }

  ngOnInit(): void
  {
      this.checkResolution();
      super.ngOnInit();

      this.activatedRoute.queryParams
        .subscribe(params =>
        {
          this.queryParams = Object.assign({}, params ?? {});
          this.id = +this.queryParams.caseId;
          this.newCase = this.queryParams.newCase;
          if (this.id) {
            this.getById(this.id);
          }
          else
          {
            if (AppClientContext.Instance.customerId)
            {
              this.customerId = AppClientContext.Instance.customerId;
              this.initializeCase();
            }
          }
          
        });


      // this.initializeStepper();

      this.caseWizardService.getOnNextStep()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() =>
        {
          this.onNextStep();
        });

      this.caseWizardService.getOnPreviousStep()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() =>
        {
          this.onPreviousStep();
        });

      // Observables
      BroadcastManager.Instance.on(AppEventNames.onUpdateProtocolForUseAligners)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          if(data)
          {
            data[0].caseId = this.currentEntity.id;
            this.protocolForUseAlignersData = data[0];
            this.updateSetupProtocolForUseAligners();
          }
        });

      BroadcastManager.Instance.on(AppEventNames.onCompositeValidity)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.isCompositeFormValid = data[0];
        });

      BroadcastManager.Instance.on(AppEventNames.onPhotographyValidity)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.isPhotographyFormValid = data[0];
        });

      BroadcastManager.Instance.on(AppEventNames.onSTLValidity)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.isSTLFormValid = data[0];
        });
      
      BroadcastManager.Instance.on("step5Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep5Valid = data[0];
        });

      BroadcastManager.Instance.on("step1Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep1Valid = data[0];
        });
      BroadcastManager.Instance.on("step2Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep2Valid = data[0];
        });

        BroadcastManager.Instance.on("step3Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep3Valid = data[0];
        });

        BroadcastManager.Instance.on("step4Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep4Valid = data[0];
        });

        BroadcastManager.Instance.on("step9Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep9Valid = data[0];
        });

        BroadcastManager.Instance.on("step6Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep6Valid = data[0];
        });

        BroadcastManager.Instance.on("step7Valid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.formStep7Valid = data[0];
        });

        BroadcastManager.Instance.on("finalStepValid")
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.finalStepValid = data[0];
        });

        BroadcastManager.Instance.on(AppEventNames.onPrescriptionDocumentCreated)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.showConfirmButton = true;
        });

  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // ********************************************************************************
  // #region Method Stepper
  // ********************************************************************************
  public initializeStepper(): void
  {
    if (!this.stackRoutes.length)
    {
      let datailPatientUrl = this.crudCaseStepsArrayExtended.find(x=> x.name == 'Paciente Detalle').url;
      if(this.router.url?.contains(datailPatientUrl)){
        this.notCompleted= true;
        this.getRoutesInStack(this.setupData.currentStep - 1);
        this.currentRoute = this.crudCaseStepsArrayExtended[this.setupData.currentStep].url;
        if(this.setupData.currentStep != 0)
        {
          this.previousRoute = this.crudCaseStepsArrayExtended[this.setupData.currentStep - 1].url;
        }
        this.onNavigate(this.currentRoute);
        //this.stackRoutes.push(this.crudCaseStepsArrayExtended.find(x=> x.name == 'Paciente Detalle').url); 
        
      }else{
        this.notCompleted =false;
        this.currentRoute = this.crudCaseStepsArrayExtended.find(x => this.router.url?.contains(x.url)).url;
        this.onNavigate(this.currentRoute);
      }

      return;
    }
  }

  public onNextStep(): void
  {
    this.previousRoute = this.currentRoute;
    this.stackRoutes.add(this.previousRoute);
    this.currentRoute = this.crudCaseStepsArrayExtended[this.stackRoutes.length].url;
    this.loading = true;
    let body;
    if(this.setupData)
    {
      if(this.previousRoute != 'prescripcion/9')
      {
        body = {
          id: this.setupData.id,
          currentStep: this.stackRoutes.length
        };
      }
      else
      {
        body = {
          id: this.setupData.id,
          currentStep: 2,
          resetCurrentStepToStart: true
        };
      }
    }


    if (this.crudCaseStepsArray.any(x => x.url == this.currentRoute))
    {
      this.selectedStepIndex = this.stepper.selectedIndex = this.crudCaseStepsArray.findIndex(x => x.url == this.currentRoute);

      setTimeout(() => {
        if(this.setupData)
        {
          this.updateSetupCurrentStep(body);
        }
        this.onNavigate(this.currentRoute, this.paramStep);
      },500)

    }
    else
    {
      setTimeout(() => {
        if(this.setupData)
        {
          this.updateSetupCurrentStep(body);
        }
        this.onNavigate(this.currentRoute, this.paramStep);
      },500)
    }
    this.cdr.detectChanges();
  }

  public onPreviousStep(clearParams: boolean = false): void
  {
    if (clearParams)
      this.paramStep = null;

    if (this.previousRoute != null)
    {
      this.stackRoutes.pop();
      this.currentRoute = this.previousRoute;

      if (this.stackRoutes.length != 0)
        this.previousRoute = this.stackRoutes[this.stackRoutes.length - 1];
      else
        this.previousRoute = null;

      this.loading = true;

      if (this.crudCaseStepsArray.any(x => x.url.contains(this.currentRoute.split('/')[0])))
      {
        this.selectedStepIndex = this.stepper.selectedIndex = this.crudCaseStepsArray.findIndex(x => x.url.contains(this.currentRoute.split('/')[0]));
        setTimeout(() => {
          this.onNavigate(this.currentRoute, this.paramStep);
        },1000)
      }
      else
      {
        setTimeout(() => {
          this.onNavigate(this.currentRoute, this.paramStep);
        },1000)
      }
    }
    this.cdr.detectChanges();
  }

  private updateSetupCurrentStep(body: any)
  {
    this.setupDataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {

    });
  }

  private onNavigate(url: string, params: any = null): void
  {
    if (params)
      this.router.navigate([`${url}`, params], {relativeTo: this.activatedRoute, queryParams: this.queryParams});
    else
      this.router.navigate([`${url}`], {relativeTo: this.activatedRoute, queryParams: this.queryParams});
      
    this.cdr.detectChanges();
    this.loading = false;
  }

  // MultiStep navigation
  public goBack():void { this.stepper.previous(); }

  public goForward():void { this.stepper.next(); }

  // ********************************************************************************
  // #region Method Patient
  // ********************************************************************************
  // Step 1
  public onSelectPatient(): void
  {
    if(this.patientId != 0)
    {
      this.paramStep = this.patientId;
      this.onNextStep();
    }
    else
      this.setInfoAlert("Es necesario primero seleccionar ó crear un paciente");
  }

  // Step 2
  public onSetPatient(): void
  {
    if (this.patientId)
    {
      this.paramStep = null;
      // Check if have an Id
      if (this.id)
      {
        this.initializeSetup();
      }
      else
      {
        this.createNewInitialSetup();
      }
    }
  }

  public get patientId(): number
  {
    return this.caseWizardService.getCurrentCase().patientId;
  }

  public havePatientId(): boolean
  {
    return this.patientId != 0;
  }

  public onGetBackToPatientDetail(): void
  {
    this.paramStep = this.patientId;
    this.onPreviousStep();
  }
  // ********************************************************************************
  // #region Method Setup
  // ********************************************************************************
  // Setup method - Create Initial Blank Setup
  private createNewInitialSetup(): void
  {
    this.loading = true;

    let blankSetupCommand: ICreateBlankCommandSetup =
    {
      customerId: this.customerId
    };

    this.setupDataService.createBlankSetup(blankSetupCommand)
      .subscribe((response: any) =>
      {
        this.setupData = response;
        this.setSetupIdInCurrentEntity();
        this.loading = false;
        let body = {
          id: this.setupData.id,
          isNextStep:true
        }
        this.updateSetupCurrentStep(body);
        this.insert();
      }, fail =>
      {
        this.setWarningAlert(fail.errorDetail.error.message);
      });
  }

  private initializeSetup(): void
  {
    if (!this.setupData)
    {
      this.setupDataService.getSetupIdByCaseId(this.currentEntity.id)
        .subscribe(response =>
        {
          this.setupData = response;
          this.setSetupIdInCurrentEntity();
          this.update();
        });
    }
    else
    {
      this.setSetupIdInCurrentEntity();
      this.setSetupIdInCurrentEntity();
      this.update();
    }
  }

  private setSetupIdInCurrentEntity(): void
  {
    AppClientContext.Instance.initializeSetup(this.setupData);

    this.currentEntity.setupId = this.setupData.id;
    this.currentEntity.prescriptionId = this.setupData.prescriptionId;
    this.currentEntity.caseFileId = this.setupData.caseFileId;

    this.caseWizardService.setCurrentCaseInfo(this.currentEntity);
    BroadcastManager.Instance.broadcast("on-load-setup", true);
  }

  // ********************************************************************************
  // #region Method CaseStage
  // ********************************************************************************
  // CaseStage method - Create Initial Blank CaseStage
  private createNewInitialCaseStage(): void
  {
    let queryDef = new UrlQueryDef();

    this.loading = true;

    let blankCaseStageCommand: ICreateBlankCommandCaseStage =
    {
      caseId: this.currentEntity.id,
      frecuencyDays: 0,
      lowerAligners: 0,
      stageNumber: 1,
      upperAligners: 0,
      setupId: this.setupData.id,
      statusId: StatusesID.InProcessOfDischarge, // Initial Status
      comments: "Etapa inicial del caso"
    };

    this.caseStageDataService.insert(blankCaseStageCommand, queryDef.getRequestConfig(true))
      .subscribe((response: any) =>
      {
        this.caseWizardService.caseStageId = response.id;
        this.loading = false;
        this.onNextStep();
      }, fail =>
      {
        this.setWarningAlert(fail.errorDetail.error.message);
      });
  }

  // ********************************************************************************
  // #region Method Case
  // ********************************************************************************
  private initializeCase(): void
  {
    this.currentEntity.purchasedAligners = 0;
    this.currentEntity.usedAligners = 0;
    this.currentEntity.usedUpperAligners = 0;
    this.currentEntity.usedLowerAligners = 0;
    this.currentEntity.customerId = this.customerId;
    this.currentEntity.isPartialSave = true;
    this.currentEntity.patientId = 0;
    this.currentEntity.setupId = 0;

    this.caseWizardService.setCurrentCaseInfo(this.currentEntity);
  }

  private updateSetupProtocolForUseAligners(): void
  {
    this.dataService.updateProtocolForUseAligners(this.protocolForUseAlignersData)
      .subscribe(response =>
      {
        //this.currentEntity.upperAligners = this.protocolForUseAlignersData.upperAligners;
        //this.currentEntity.lowerAligners = this.protocolForUseAlignersData.lowerAligners;
        this.setSuccessAlert("¡Setup terminado con éxito!");
        BroadcastManager.Instance.broadcast(AppEventNames.onGeneratePrescriptionDocument, true);
      }, fail =>
      {
        this.setWarningAlert(fail.error.errorDetail.message);
      });
  }

  public exitCrudCase():void
  {
    this.router.navigate(['/ecommerce/mis-casos']);
  }

  public onNextPrescriptionStep(): void
  {
    BroadcastManager.Instance.broadcast(AppEventNames.onUpdatePrescriptionStepByNumber, this.currentRoute.split("/")[1]);

    if (!(this.currentRoute == this.crudCaseStepsArrayExtended[12].url && !this.showConfirmButton))
    {
      this.onNextStep();
    }
   
  }

  public onConfirmCase(): void
  {
    let queryDef = new UrlQueryDef();

    queryDef.filter = 'CaseId eq ' + this.currentEntity.id;
    queryDef.orderby = 'StageNumber';
    this.caseStageDataService.get(queryDef)
    .subscribe((caseStages:any)=>
    {
      this.caseStages=caseStages.rows;
      if(this.caseWizardService.confirmCase)
      {
        let currentCaseStage=this.caseStages.reduce((previous, current) => {
          return current.stageNumber > previous.stageNumber && !current.isDeleted ? current : previous;
        })
        
        this.currentEntity.isPartialSave = false;
        this.finalStep = true;
        this.update();
      }
      else
      {
        this.onDeleteCase();
      }
  
      // Remove temporal case data
      localStorage.removeItem('newCaseTempData');
      this.updateSetup();
      BroadcastManager.Instance.broadcast(AppEventNames.onCompleteCase, true);
    });

  }


  private onDeleteCase(): void
  {
    let queryDef = new UrlQueryDef();
    this.loading = true;

    // Get Setup Data
    let setup = AppClientContext.Instance.setup;

    // Delete CaseStage
    this.caseStageDataService.delete(this.caseWizardService.caseStageId, queryDef.getRequestConfig(true));

    // Delete Patient
    this.patientDataService.delete(this.caseWizardService.getCurrentCase().patientId, queryDef.getRequestConfig(true));

    // Delete Setup
    this.setupDataService.deleteAllSetup(setup.id);
    this.delete();
  }
  // ********************************************************************************
  // #region Method Overrides Case
  // ********************************************************************************

  protected onAfterInsert(currentEntity: any)
  {
    if (this.currentEntity)
    {
      // Set CaseId for udpdate steps
      AppClientContext.Instance.customerCaseId = currentEntity.id;
      AppClientContext.Instance.initializeCase(currentEntity);

      // Set currentEntity
      this.currentEntity = currentEntity;

      // Update LocalStorage
      this.caseWizardService.setCurrentCaseInfo(this.currentEntity);

      // Create initial stage
      this.createNewInitialCaseStage();
    }
    else
      this.loading = false;
  }

  protected onAfterUpdate(currentEntity: any): void
  {
    if (this.currentEntity)
    {
      // Set CaseId for udpdate steps
      AppClientContext.Instance.customerCaseId = currentEntity.id;
      AppClientContext.Instance.initializeCase(currentEntity);

      // Set currentEntity
      this.currentEntity = currentEntity;

      // Update LocalStorage
      this.caseWizardService.setCurrentCaseInfo(this.currentEntity);
      

      if (this.finalStep == true) {
        let currentCaseStage = this.caseStages.reduce((previous, current) => {
          return current.stageNumber > previous.stageNumber && !current.isDeleted ? current : previous;
        })

        let body =
        {
          id: currentCaseStage.id,
          caseId: currentEntity.id,
          statusId: StatusesID.StageReceived,
          stageNumber: currentCaseStage.stageNumber,
          commentsBackoffice: "",
          commentsEcommerce: "",
          updateStageReceivedDateRequired: true,
        };
        this.caseStageDataService.updateStatus(body)
          .subscribe(() => {
            this.finalStep = false;
            this.onNextStep();
          });
      }
      else {
        this.finalStep = false;
        this.onNextStep();
      }
    }
    else
      this.loading = false;
  }

  public delete(): void
  {
    let id: number = this.caseWizardService.getCurrentCase().id;

    this.dataService.delete(id, this.getQueryDefForGetById().getRequestConfig(true))
      .subscribe((response: any) =>
      {
        this.clearAlert();

        this.add();
        this.onAfterDelete(this.currentEntity);
        this.setCurrentEntity(null);

        this.publishCrudOperationCompleted("Registro eliminado");
      },
      (fail) =>
      {
        this.setDangerAlert(fail.error);
      });
  }

  protected onAfterDelete(currentEntity: any): void
  {
    this.currentEntity = currentEntity;
    AppClientContext.Instance.case = Object.create(null);
    this.exitCrudCase();
    this.setInfoAlert("Caso descartado correctamente");
  }

  protected onAfterGetById(currentEntity: any)
  {
    this.caseWizardService.setCurrentCaseInfo(this.currentEntity);
    AppClientContext.Instance.initializeCase(this.currentEntity);
    //charge data of setup
    if(!this.newCase)
    {
      this.setupDataService.getSetupIdByCaseId(this.currentEntity.id)
      .subscribe(response =>
      {
        this.setupData = response;
        this.setSetupIdInCurrentEntity();
        this.initializeStepper();
      });
    }

    


    super.onAfterGetById(currentEntity);
  }

  protected onGetQueryDefForGetById(queryDef: UrlQueryDef): void
  {
    queryDef.includes = 'Customer,Patient,Product,CaseStages';
    super.onGetQueryDefForGetById(queryDef);
  }

  public insert(): void
  {
    this.onBeforeInsert(this.currentEntity);

    this.dataService.insert(this.currentEntity, this.getQueryDefForGetById().getRequestConfig(true))
      .subscribe((response: any) =>
      {
        this.clearAlert();

        let id: number = response.id != undefined ? response.id : response; //sometimes 'response' already have the id

        this.currentEntity.id = id;

        this.dataService.getById(id, this.getQueryDefForGetById())
          .subscribe((response: any) =>
          {
            this.getByIdCallback(response);
            this.publishCrudOperationCompleted("Registro agregado");
            this.publishEntitySelected();

            this.onAfterInsert(this.currentEntity);
          });
      },
      (fail) =>
      {
        var outputs = this.CreateErrorMessage(fail.error.failures);
        this.setDangerAlert(fail.error.message + outputs);
        this.loading = false;
      });
  }

  /*
   * Methods used to detect the screen resolution */
  @HostListener('window:resize', ['$event'])
  onResize(event)
  {
    this.checkResolution();
  }
  private checkResolution(): void
  {
    if (window.innerWidth < 700 && window.innerHeight < 1020)
    {
      this.size700_1020 = true;
    }
    else
    {
      this.size700_1020 = false;
    }
  }
  // ********************************************************************************
  // #region Method StartupInfo
  // ********************************************************************************
  private getStartupInfo()
  {
    this.systemServicesDataService.getStartupInfo()
      .subscribe((startupInfo) =>
      {
        this.onApplicationStartup(startupInfo);
      }, error =>
      {
        if (error.status == 401)
        {
          this.forceLogout();
        }
      });
  }

  private onApplicationStartup(startupInfo: any)
  {
    AppClientContext.Instance.initialize(startupInfo);

    // Save a reference to the angular injector to the client context
    AppClientContext.Instance.setInjector(this.injector);

    this.getCustomerInfo();
  }

  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentUser = response.items.firstOrNull();
          if (currentUser)
          {
            AppClientContext.Instance.customerId = currentUser.id;
          }
        });
    }
  }

  public forceLogout(): void
  {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');

    // Remove Token
    AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

    // Clear current user
    AppClientContext.Instance.user = null;
  }

  private getUserLoginFromCache(): boolean
  {
    let user = JSON.parse(localStorage.getItem('currentUser'));
    return this.setSecurityToken(user);
  }

  public disabledButtonStages():boolean
  {
    if(this.currentRoute == "prescripcion/5" && !this.formStep5Valid || (this.currentRoute == "prescripcion/6" && !this.formStep6Valid)|| (this.currentRoute == "prescripcion/7" && !this.formStep7Valid) || (this.currentRoute == "prescripcion/1" && !this.formStep1Valid)|| (this.currentRoute == "prescripcion/2" && !this.formStep2Valid)
      || (this.currentRoute == "prescripcion/3" && !this.formStep3Valid)|| (this.currentRoute == "prescripcion/4" && !this.formStep4Valid)|| (this.currentRoute == "confirmacion-caso" && !this.finalStepValid))
    {
      return true;
    }
    return false;
  }

  private setSecurityToken(user: any): boolean
  {
    if (user && user.cacheToken)
    {
      // Remove Token
      AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

      // Append Token
      AppClientContext.Instance.headerValues.set(ECOMMERCE_USER_TOKEN, user.cacheToken);

      return true;
    }
    return false;
  }

  private getRoutesInStack(currentRouteNumber: number)
  {
    let route = 0; 
    while(route <= currentRouteNumber)
    {
      this.stackRoutes.add(this.crudCaseStepsArrayExtended[route].url);
      route+=1;
    }
  }

  public updateSetup()
  {
    let body = 
    {
      id: AppClientContext.Instance.setup.id,
      prescriptionId: AppClientContext.Instance.setup.prescriptionId,
      caseFileId: AppClientContext.Instance.setup.caseFileId,
      isPartialSave: false

    }
    this.setupDataService.updateSetupById(body)
    .subscribe((res)=>
    {
    });
  }
}
